
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TombstoneParsedGameData} from "../server/data/TombstoneParsedGameData";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {TombstoneGameModuleConfig} from "../TombstoneGameModuleConfig";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {TombstoneNoMercy} from "../TombstoneNoMercy";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";


export class TBNMSpinReelController extends NudgeSpinReelController {

    private gameData:TombstoneParsedGameData;

    constructor(reelId:number) {
        super(reelId);
    }


    public onGameDataParsed(data:TombstoneParsedGameData):void {
        super.onGameDataParsed(data);
        this.gameData = data;
        this._nextFullReelSet = Helper.getReelSet(data.nextReelSetName, this._reelId);
        this._nearWinBigWinReels = data.nearWinBigWinReels.concat();

        this._nearWinReels = data.nearWinClientReels;
    }

    protected tryPlayNearWin(reelId:number):void {
        if(reelId !== this.reelId) {
            return;
        }

        if((this.hasNearWin() && this.currentState === ReelAnimationState.SPIN)) {

            if(!(this.gameData.mode === GameMode.NORMAL && (TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_BIG" || TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_SMALL"))) {
                this.playNearWin(reelId);
            }
        }
    }

    protected getNormalStopDelay(reelId: number): number {

        if((TombstoneGameModuleConfig.gameData.wasFeatureBuy && this.gameData.mode === GameMode.NORMAL) && (TombstoneGameModuleConfig.initData.buyFeatureName === "SUPER_FREESPIN" || TombstoneGameModuleConfig.initData.buyFeatureName === "FREESPIN")) {
            return this.getFastSpinStopDelay(this.reelId);
            //return ReelController._reelStopDelays[reelId];
        }

        if((TombstoneGameModuleConfig.gameData.wasFeatureBuy && this.gameData.mode === GameMode.NORMAL) && (TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_BIG" || TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_SMALL")) {

            return this.getFastSpinStopDelay(this.reelId);
            //return [0, 0.2,0.2,0.2, 0][reelId];
        }


        return super.getNormalStopDelay(reelId);
    }

    protected getStopDelayDelta(stopSpinData: IReelStopSpinData): number {

        if((TombstoneGameModuleConfig.gameData.wasFeatureBuy && this.gameData.mode === GameMode.NORMAL) && (TombstoneGameModuleConfig.initData.buyFeatureName === "SUPER_FREESPIN" || TombstoneGameModuleConfig.initData.buyFeatureName === "FREESPIN")) {
            return this.getFastSpinStopDelay(this.reelId);
            //return ReelController._reelStopDelays[reelId];
        }

        if((TombstoneGameModuleConfig.gameData.wasFeatureBuy && this.gameData.mode === GameMode.NORMAL) && (TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_BIG" || TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_SMALL")) {

            return this.getFastSpinStopDelay(this.reelId);
            //return [0, 0.2,0.2,0.2, 0][this.reelId];
        }



        return super.getStopDelayDelta(stopSpinData);
    }

}